import {
  type Language,
  type LanguageProficiencyLevel,
} from '#app/__generated__/api.js';
import { type ExcludeRelayFutureAddedValue } from '#app/types/utils.js';

export const WORK_PREFERENCES_MAX_TOOLS = 10;

export const WORK_PREFERENCES_MAX_LANGUAGES = 5;

type LanguageKeys = ExcludeRelayFutureAddedValue<Language>;

export const PROFESSIONAL_LANGUAGE_LABELS: Record<LanguageKeys, string> =
  Object.freeze({
    AMERICAN_SIGN_LANGUAGE: 'American Sign Language',
    ARABIC: 'Arabic',
    CANTONESE: 'Cantonese',
    DUTCH: 'Dutch',
    ENGLISH: 'English',
    FRENCH: 'French',
    GERMAN: 'German',
    HINDI: 'Hindi',
    ITALIAN: 'Italian',
    JAPANESE: 'Japanese',
    KOREAN: 'Korean',
    MANDARIN: 'Mandarin',
    PORTUGUESE: 'Portuguese',
    RUSSIAN: 'Russian',
    SPANISH: 'Spanish',
    THAI: 'Thai',
    TURKISH: 'Turkish',
    UKRAINIAN: 'Ukrainian',
  });

export const PROFESSIONAL_LANGUAGE_PROFICIENCY_LABELS: Record<
  ExcludeRelayFutureAddedValue<LanguageProficiencyLevel>,
  string
> = Object.freeze({
  FLUENT: 'Fluent',
  LIMITED_WORKING: 'Limited Working Proficiency',
  PROFESSIONAL_WORKING: 'Professional Working Proficiency',
});

export const isValidLanguage = (language: string): language is LanguageKeys => {
  return language in PROFESSIONAL_LANGUAGE_LABELS;
};
